import { Box } from '@mui/material';
import { memo } from 'react';

function ProjectRoleBox({ roleCode, roleName }: { roleCode: string; roleName: string }): JSX.Element {
  const roleBackground: { [key: string]: string } = {
    ROLE_ADMIN_SUPER: 'mind.custom.adminButton',
    GUEST: 'mind.custom.guestButton',
  };

  const roleFontColor: { [key: string]: string } = {
    ROLE_ADMIN_SUPER: 'mind.custom.white',
    ROLE_MANAGER: 'mind.black.A0',
    GUEST: 'mind.custom.description',
  };
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: roleBackground[roleCode] ?? 'mind.custom.tableHead',
        color: roleFontColor[roleCode] ?? 'mind.custom.white',
        height: 24,
        typography: 's12w400',
        borderRadius: '4px',
        minWidth: 50,
        textTransform: 'capitalize',
      }}
    >
      {roleName ?? '-'}
    </Box>
  );
}

export default memo(ProjectRoleBox);
